import { z } from 'zod'

export const questionOptionObject = z.object({
  id: z.string().describe('ID'),
  questionId: z.string().describe('ID da pergunta').nullish(),
  label: z.string().describe('Rótulo'),
})
